import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function XMarkIcon(props) {
    return (
        <SvgIcon {...props} stroke="currentColor" strokeWidth={1.5}>
            <path d="M6 18 18 6M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
}

export default XMarkIcon;
